<template>
  <form @submit.prevent="addTitle">
    <label>
      <span>Title</span>
      <input :disabled="toEdit" type="text" placeholder="Intern" autofocus v-model="name">
    </label>
    <label>
      <span>Level</span>
        <select :disabled="toEdit" v-model="selected">
          <option value="">select level</option>
          <option v-for="(level, index) in levels" :value="level.title">{{level.title}}</option>
        </select>
    </label>
    <div>
      <button v-show="!toEdit" class="btn--save" type="submit">Save & Continue</button>
      <button v-show="!toEdit" class="btn--cancel" type="reset" @click="cancelAddTitle">Cancel</button>
    </div>
  </form>
</template>

<script>
import * as types from "../../../store/constant";

export default {
  name: "TitlesForm",
  props: ['title', 'edit'],
  data() {
    return {
      name: this.$props.title ? this.$props.title.name : null,
      level: this.$props.title ? this.$props.title.level : null,
      toEdit: this.$props.edit ? this.$props.edit : false,
      levels: [],
      selected: "",
      successMsg: "",
      errorMsg: ""
    }
  },
  created() {
    this.$http.get(types.EMPLOYMENT_LEVEL_API)
      .then(resp => {
        this.successMsg = resp.message;
        this.levels = resp.data.data;
      })
      .catch(err => {
        this.errorMsg = err.message;
      })  
  },
  methods: {
    addTitle() {
      const titlesFormData = {
        title: this.name,
        level: this.selected
      }

      this.$http.post(types.GET_DESIGNATION_API, titlesFormData)
        .then(resp => {
          this.successMsg = resp.message;
        })
        .catch(err => {
          this.errorMsg = err.message;
        })
    },
    cancelAddTitle() {

    }
  }
}
</script>

<style lang="scss" scoped>
  form {
    padding: 50px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

    > label {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 40px;

      > span {
        flex: 0 0 13%;
      }
      
      > input, select {
        display: inline-block;
        flex: 0 0 45%;
        height: 30px;
        padding: 5px;
        border: 1px solid rgba(0, 0, 0, 0.2);
      }

      > input::placeholder{
        color: #000000;
      }
    }

    > div {
      margin-top: 70px;
      display: flex;
      flex-direction: row;
      justify-content: center;

      > button  {
        flex: 0 0 15%; 
        height: 35px;
        border: 0;
        outline: 0; 
        border-radius: 5px;
      }

      > .btn--save {
        background-color: #5099de;
        color: #fff;
        margin-right: 20px;
        font-size: 0.878vw;
      }

      > .btn--cancel {
        background-color: #fff;
        border: 1px solid rgba(0, 0, 0, 0.2);
        margin-left: 20px;
        color: rgba(0, 0, 0, 0.6);
        font-size: 0.878vw;
      }   
    }
  }
</style>